// frontend/src/components/OctoAppTypeForm.js
import React, {useState} from 'react';
import {OverlayTrigger, Popover} from 'react-bootstrap';

const popoverOctoVersion = (
    <Popover id="popover-basic">
        <Popover.Body>
            Version of Octo+ to deploy. This fiels is mandatory <br/><br/>
            You can deploy a release version by entering two first digit of the version. For example "8.0" will deploy
            the last "8.0.X" <br/><br/>
            You can deploy a Change set version by entering the associated jira ticket number. For example ORET-8022
            will deploy the last version of the ticket.
        </Popover.Body>
    </Popover>
);

const popoverInfraVersion = (
    <Popover id="popover-basic">
        <Popover.Body>
            Version of Octo+ Infrastructure to deploy. This field is optionnal <br/><br/>
            If empty, the last version of Octo+ Infrastructure related to Octo+ Version will be deployed.<br/><br/>
            If not empty you have to enter the exact version of Octo+ Infrastructure to deploy.
        </Popover.Body>
    </Popover>
);

const OctoAppTypeForm = ({
                             currentPath,
                             versionFields,
                             handleVersionChange,
                             triggerUpdateAppPipeline,
                             pipelineState,
                             triggerOctoAppStartPipeline,
                             triggerOctoAppStopPipeline,
                             triggerOctoAppRestartPipeline,
                             triggerArgoAppUpdatePipeline,
                             muteAppAlerts,
                             actionInProgress,
                             goBack,
                             otherEnvsVersion,
                             envVersionsLoading,
                             currentEnvInfos

                         }) => {


        const [error, setError] = useState("");

        const validateInputs = () => {
            const octoVersionPattern = /^\d+\.\d+\.\d+$/; // Matches "0.0.0" pattern
            if (octoVersionPattern.test(versionFields.octoVersion) && !versionFields.infraVersion) {
                setError("Infra Version cannot be empty when Octo Version matches the pattern X.X.X");
                return false;
            }
            setError("");
            return true;
        };

        const handleSubmit = () => {
            if (validateInputs()) {
                triggerUpdateAppPipeline();
            }
        };
        return (
            <div className="card shadow-sm">
                <div className="card-body ps-4 pe-4">
                    <div className='d-flex flex-row align-items-baseline gap-2 mb-4'>
                        {currentPath && (
                            <button className="btn d-flex align-items-center" type="button" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                            </button>
                        )}
                        <h3 className="h5 text-primary mb-3">Octo+ App: {currentPath.split('/').pop()} </h3>
                    </div>

                    <div className="d-inline-flex justify-content-around w-100 gap-5">
                        <div className="w-100">
                            <h5>Update</h5>
                            <p className="p-2 text-bg-light text-black-50">Be sure to monitor the pipeline closely to ensure
                                the
                                update is operational.</p>
                            <div className="mb-3 mt-4">
                                <label className="form-label">Octo Version:
                                    <OverlayTrigger trigger="hover" placement="right" overlay={popoverOctoVersion}>
                                        <i className="bi bi-question-circle ms-2"></i>
                                    </OverlayTrigger>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={versionFields.octoVersion}
                                    onChange={(e) => handleVersionChange("octoVersion", e.target.value)}
                                    placeholder="8.0, ORET-8022 ..."
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Infra Version ( optionnel ):
                                    <OverlayTrigger trigger="hover" placement="right" overlay={popoverInfraVersion}>
                                        <i className="bi bi-question-circle ms-2"></i>
                                    </OverlayTrigger>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={versionFields.infraVersion}
                                    onChange={(e) => handleVersionChange("infraVersion", e.target.value)}
                                    placeholder="Enter Infra Version"
                                />
                            </div>
                            {error && <div className="text-danger mb-3">{error}</div>}
                            <button
                                className={`btn ${
                                    pipelineState === "idle"
                                        ? "btn-primary"
                                        : pipelineState === "loading"
                                            ? "btn-warning"
                                            : pipelineState === "success"
                                                ? "btn-success"
                                                : "btn-danger"
                                } d-flex align-items-center justify-content-center`}
                                onClick={handleSubmit}
                                disabled={pipelineState === "loading"}
                            >
                                {pipelineState === "loading" ? (
                                    <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"
                              aria-hidden="true"></span>
                                        Triggering...
                                    </>
                                ) : pipelineState === "success" ? (
                                    <>
                                        <i className="bi bi-check-circle-fill me-2"></i>
                                        Success
                                    </>
                                ) : pipelineState === "failed" ? (
                                    <>
                                        <i className="bi bi-exclamation-circle-fill me-2"></i>
                                        Failed
                                    </>
                                ) : (
                                    "Trigger Pipeline"
                                )}
                            </button>
                        </div>
                        <div className=""></div>
                        <div className="vr"></div>
                        <div className=""></div>
                        <div className="w-100">
                            <h5>Actions</h5>
                            <p className="p-2 text-bg-light text-black-50">One rule: If you wonder what it's for, move
                                along!</p>
                            <div className="flex gap-3 mb-3 mt-3">
                                {!actionInProgress && (
                                    <>
                                        <div className="d-inline-flex gap-3 mb-3 mt-3">
                                            <button className="btn btn-outline-dark d-flex align-items-center"
                                                    type="button"
                                                    onClick={muteAppAlerts}>
                                                <i className="bi bi-volume-mute-fill  me-2"></i> Mute Alerts
                                            </button>
                                            <button className="btn btn-outline-info d-flex align-items-center"
                                                    type="button"
                                                    onClick={triggerArgoAppUpdatePipeline}>
                                                <i className="bi bi-arrow-clockwise  me-2"></i> Argo App Update
                                            </button>
                                            <button className="btn d-flex btn-outline-success align-items-center"
                                                    type="button"
                                                    disabled={true}
                                                    onClick={triggerOctoAppStartPipeline}>
                                                <i className="bi bi-play me-2"></i>Start (soon)
                                            </button>
                                            <button className="btn btn-outline-danger d-flex align-items-center"
                                                    type="button"
                                                    disabled={true}
                                                    onClick={triggerOctoAppStopPipeline}>
                                                <i className="bi bi-stop me-2"></i>Stop (soon)
                                            </button>
                                            <button className="btn btn-outline-warning d-flex align-items-center"
                                                    type="button"
                                                    disabled={true}
                                                    onClick={triggerOctoAppRestartPipeline}>
                                                <i className="bi bi-arrow-clockwise  me-2"></i> Restart (soon)
                                            </button>
                                        </div>

                                    </>
                                )}

                                {actionInProgress && (
                                    <div className="text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                    </div>


                    <div className=" justify-content-around w-100 gap-15">
                        <div className="w-100 mt-5">
                            <h5>Versions</h5>

                            <table className="table mt-2">
                                <thead>
                                <tr>
                                    <th scope="col">Environment</th>
                                    <th scope="col">Octo version</th>
                                    <th scope="col">Infra version</th>
                                </tr>
                                </thead>
                                <tbody>
                                {( currentEnvInfos && (<tr>
                                    <th scope="row" className={"text-primary"}> {currentEnvInfos.environment}</th>
                                    <td className={"text-primary"}> {currentEnvInfos.octoVersion}</td>
                                    <td className={"text-primary"}> {currentEnvInfos.infraVersion}</td>
                                </tr>
                                ))}
                                {(otherEnvsVersion.map((item => (
                                    <tr>
                                        <th scope="row">{item.environment}</th>
                                        <td> {item.octoVersion}</td>
                                        <td> {item.infraVersion}</td>
                                    </tr>
                                ))))}
                                </tbody>
                            </table>
                            {envVersionsLoading && (
                                <div className="text-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        );
    };
export default OctoAppTypeForm;
